import { useTranslate } from 'react-polyglot';
import { observer } from 'mobx-react';

import { useBreakpoint } from '@genially/design-system';

import { useGeniallyDescription } from '../../../../../../../../shared/application/hooks/useGeniallyDescription';
import { useGeniallyImageRenderUrl } from '../../../../../../../../shared/application/hooks/useGeniallyImageRenderUrl';
import { useGeniallyName } from '../../../../../../../../shared/application/hooks/useGeniallyName';
import { useHostClientContext } from '../../../HostClientProvider/hooks/useHostClientContext';
import { HostGameBreakdownSteps } from '../../../HostGame/HostGame.constants';
import { StartButton } from '../StartButton/StartButton';
import {
  DescriptionWrapper,
  GeniallyThumbnail,
  StyledBasicParagraph,
  StyledSmallTitle,
  Wrapper,
} from './Header.styled';

export const Header = observer(() => {
  const t = useTranslate();
  const { client } = useHostClientContext();

  const imageUrl = useGeniallyImageRenderUrl(client.geniallyId);

  const { isDownwards } = useBreakpoint();

  const isMobile = isDownwards(HostGameBreakdownSteps.forth);

  const geniallyName = useGeniallyName(client.geniallyId);
  const geniallyDescription = useGeniallyDescription(client.geniallyId);

  const description =
    geniallyDescription ?? t('__new.play.creatorLobby.templateTextDefault');

  return (
    <Wrapper>
      <GeniallyThumbnail src={imageUrl} alt="Genially Thumbnail" />

      <DescriptionWrapper>
        <StyledSmallTitle>{geniallyName}</StyledSmallTitle>
        <StyledBasicParagraph>{description}</StyledBasicParagraph>
      </DescriptionWrapper>

      {!isMobile && <StartButton />}
    </Wrapper>
  );
});
